const html = require("./html/inboundCarrierView.html");
const carrBrokerhtml = require("./html/inboundCarrierBrokerView.html");
const createCarrierOrBrokerModalBodyHtml = require('./html/createOrganizationModal.html');
const modalHtml = require("../../../sharedHtml/modal.html");
import render from "../../../utilities/render";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor, setUniqNames, setRequired} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import ShippingMethodStore from "../../../stores/ShippingMethodStore";
import BrokerStore from "../../../stores/BrokerStore";
import {isBlank} from '../../../utilities/general';
import { create } from "domain";
import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";
/*import CaseArrivalAndTrackingRowView from "./CaseArrivalAndTrackingRowView";*/


const elementsMap = {
  inboundCarrierOuter: ".inbound-carrier-outer",
  caseArrivalAndTrackingRows: ".case-exp-arrival-tracking-rows",
  shippingSelectOuter: ".shipping-select-outer",
  brokerSelectOuter: ".broker-select-outer",
  shippingPhoneCodeSelectOuter : ".shipping-phone-code-select-outer",
  otherFieldsOuter: ".other-fields-outer",
  palletSpecificInboundCarrierFields: ".pallet-specific-inbound-carrier-fields",
  otherCarrierInput: "#other-carrier-input",
  carrierContactNameInput: "#carrier-contact-name-input",
  carrierContactPhoneInput: "#carrier-contact-phone-input",
  carrierBolProNumberInput: "#carrier-bol-pro-number-input",
  carrierExpectedArrivalDateInput: "#carrier-expected-arrival-date-input",
  bolNumbersInput: ".carrier-bol-pro-number-input",
  trackingNumberInput: ".case-tracking-number-input",
  saveCarrier:"#save-carrier",
  createCarrier: ".create-carrier-btn",
  carrierBrokerBtnInputVal : ".carrier-broker-val",
  carrierBrokerToggler: ".carrier-broker-toggler",
  carrierBrokerOrgType : "carrier-broker-org-type",
  carrierContinueBtn : ".continue-btn"

}

let elsModal = {};


const elsModalMap = {
   carrierContinueBtn: '.continue-btn'
};

export default function InboundCarrierView(_unused, options={}){
  const self = this;
  let isUpdateVal;
  let carrierBrokerModal;
  let asn;
  const {
    getAsn,
    getAsnDetailGroups,
    isPallet,
    onShippingMethodChange,
    onAsnFieldChange,
    onAsnDetailGroupFieldChange,
    onFieldCloneToAsnDetailsChange,
    getAllCountriesPhoneCode,
    onCountryPhoneCodeChange,
    getDefaultCarriers,
    getCarrierCreateUrl
  } = options;

  self._element = $();
  const els = {};

  const modalOpts = { backdrop: 'static', show: false };
 /* let caseArrivalAndTrackingRowViews = [];*/

  self.init = function(){
    renderscreen();
  }

  self.getCarrierPhoneCode = function(){
    return els.carrierContactPhoneInput;
  }

  

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
    els.shippingSelect = generateShippingSelect();
    els.brokerSelect = generateBrokerSelect();
    els.phoneCodeSelect = generatePhoneCodeSelect();
    els.shippingPhoneCodeSelectOuter.html(els.phoneCodeSelect)
    els.shippingSelectOuter.html(els.shippingSelect);
    els.brokerSelectOuter.html(els.brokerSelect);
  }

  function generateShippingSelect(){
    const shippingMethodObject = getShippingMethods();
    let defaultCarriersJsonArray = getDefaultCarriers();
    const select = $("<select class='shipping-select' style='width:100%' data-error-placement-append-closest='div'></select>");
    var option = $('<option />');
    option.attr('value', "").text("Select Inbound Carrier");
    select.append(option);

    if( asn!=null && asn.asn_org_id!==null && asn.asn_org_id!==""  && (asn.asn_org_id===undefined ||  asn.asn_org_id!==0)){

      for (let keyValue in shippingMethodObject){
        var option = $('<option />');
        option.attr('value', shippingMethodObject[keyValue].orgId).text(shippingMethodObject[keyValue].orgName);
        select.append(option);
      }
    }else{

      for (let keyValue in shippingMethodObject){
        var option = $('<option />');
        option.attr('value', shippingMethodObject[keyValue].cdmValue).text(shippingMethodObject[keyValue].cdmValue);
        select.append(option);
      }
  
      for (let keyValue in defaultCarriersJsonArray){
        var option = $('<option />');
            option.attr('value', defaultCarriersJsonArray[keyValue].cdmValue).text(defaultCarriersJsonArray[keyValue].cdmValue);
        select.append(option);
      }

    }

    return select;
    
  }

  function generateBrokerSelect(){
    const brokerObject = getBrokers();
    const select = $("<select class='shipping-select' style='width:100%' data-error-placement-append-closest='div'></select>");
    
    var option = $('<option />');
    option.attr('value', "").text("Select Broker");
    select.append(option);
    for (let keyValue in brokerObject){
      var option = $('<option />');
					option.attr('value', brokerObject[keyValue].orgId).text(brokerObject[keyValue].orgName);
      select.append(option);
    }

    return select;
    
  }

 

  function generatePhoneCodeSelect(){
    const select = $("<select name='countryCode' id='asn-carrier-country-phone-code' class='select2-select q-input' style='width:100%' data-error-placement-append-closest='div' data-s2-placeholder='Country Code' data-s2-minimum-results-for-search='5'></select>");
    var usaCanadaPhoneCodeExists = false;
    $(getAllCountriesPhoneCode()).each(function(){
      var option = $('<option />');
      if(this.conPhoneCode === '+1'){
				if(!usaCanadaPhoneCodeExists){
					option.attr('value', this.conPhoneCode).text("United States of America/Canada +1");
          usaCanadaPhoneCodeExists = true;
				}
			}else{
				option.attr('value', this.conPhoneCode).text(this.conPhoneText);
			}
      select.append(option);
    });
    return select;
  }

  function setWidgets(){
    els.shippingSelect.select2({
      placeholder: "Select Inbound Carrier",
      minimumResultsForSearch: "Infinity"
    });
    els.brokerSelect.select2({
      placeholder: "Select Broker",
      minimumResultsForSearch: "Infinity"
    });

    els.carrierContactPhoneInput.inputmask({
      mask: "(999) 999-9999"
    });
    instantiateExpArrivalDatePicker();
   }

  function instantiateExpArrivalDatePicker(){
    const date = new Date();
    const enddate = new Date();
    enddate.setDate(enddate.getDate() + 90);
    els.carrierExpectedArrivalDateInput.datepicker({
      startDate: date,
      endDate: enddate,
      todayBtn: "linked",
      keyboardNavigation: false,
      forceParse: false,
      autoclose: true
    });
    els.carrierExpectedArrivalDateInput.keypress(function(event) {event.preventDefault();}); //make non-typeable/readonly texbox
  }

  self.getElement = function(){
    return self._element;
  }

  self.isCarrierNameValid = function(){
    return isCarrierNameValid();
  }
  
  function isCarrierNameValid (){
    let valid = true;
    if (els.shippingSelect.val() == "Other"){
      valid = validateCarrierName(els.otherCarrierInput.val());
    }

    if(valid){
      $("#duplicate-default-carrier-error-message").hide();
    }else{
      $("#duplicate-default-carrier-error-message").show();
    }

    return valid;
  }


  function renderscreen(){
    asn = getAsn();
    if(asn!=null && asn.asn_org_id!=="" && (asn.asn_org_id===undefined ||  asn.asn_org_id!==0)){
      self._element = $(carrBrokerhtml);
    }else{
      self._element = $(carrBrokerhtml);
      asn.asn_org_id = null;
    }
    buildModalHtml();
    setElementsOnModal();
     setElements();
    setUniqNames([els.otherCarrierInput, els.phoneCodeSelect,els.shippingSelect,els.brokerSelect, els.carrierContactNameInput, els.carrierContactNameInput, els.carrierContactPhoneInput, els.carrierBolProNumberInput, els.carrierExpectedArrivalDateInput,els.saveCarrier]);
    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
    setRequired([els.otherCarrierInput, els.phoneCodeSelect, els.shippingSelect,els.brokerSelect, els.carrierContactNameInput, els.carrierContactNameInput, els.carrierContactPhoneInput, els.carrierExpectedArrivalDateInput]);
    setWidgets();
    update();
    bindElements();
    bindStores();
    
  }

  
  function setElementsOnModal(){
    const $body = $('body');
    setElementsFromScope(elsModal, elsModalMap, $body);
  }

  function update(){
    updateSelf();
    updateChildren();
    els.otherFieldsOuter.hide();
  }

  function updateChildren(){
    if(!isPallet()){
/*      unbindAll(caseArrivalAndTrackingRowViews);
      caseArrivalAndTrackingRowViews = renderCaseArrivalAndTrackingRowViews();
      els.caseArrivalAndTrackingRows.html(extractElements(caseArrivalAndTrackingRowViews));*/
    }
  }

  function updateSelf(){
    //Update carrier values from AsnStore
    updateCarrierValues();

    handleDisplayFor(els.otherFieldsOuter, isInboundCarrierOther());
    handleDisplayFor(els.palletSpecificInboundCarrierFields, isPallet());
    // handle children insertion container display:
    // hide for pallet (these rows are case specific)
    handleDisplayFor(els.caseArrivalAndTrackingRows, !isPallet());
  }

  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", update);
    AsnStore.bindListener("asns:change", updateSelf);
    AsnDetailStore.bindListener("asn_details:add", update);
    AsnDetailStore.bindListener("asn_details:remove", update);
  }

  function bindElements(){
    els.shippingSelect.on("change", onShippingSelectChangeCb);
    els.brokerSelect.on("change", onBrokerSelectChangeCb);
    els.phoneCodeSelect.on("change", onCountryPhoneCodeChangeCb);
    els.otherCarrierInput.on("change", isCarrierNameValid);
    els.otherCarrierInput.on("blur", onAsnFieldChangeFunc("asn_carrier_name"));
    els.carrierContactNameInput.on("blur", onAsnFieldChangeFunc("asn_carrier_contact_name"));
    els.carrierContactPhoneInput.on("blur", onAsnFieldChangeFunc("asn_carrier_phone"));
    els.carrierBolProNumberInput.on("blur", onAsnFieldChangeFunc("asn_bol_pro_number"));
    els.carrierExpectedArrivalDateInput.on("input change", onAsnFieldChangeFunc("asn_expected_arrival_date"));
    els.trackingNumberInput.on("blur", onFieldCloneToAsnDetailsChangeFunc("asd_tracking_number"));
    els.carrierExpectedArrivalDateInput.on("input change", onFieldCloneToAsnDetailsChangeFunc("asd_expected_arrival_date"));
    els.saveCarrier.on("click", onAsnFieldChangeFunc("asn_save_carrier"));
    els.createCarrier.on("click", showCarrierOrgModal);
    elsModal.carrierContinueBtn.on("click", handleCarrierBrokerModalClose);
    
  }

  function handleCarrierBrokerModalClose(e){
    e.preventDefault();
    carrierBrokerModal.modal("hide");
    
    console.log('carrierCreateUrl'+getCarrierCreateUrl());
    if(AsnStore.getCarrierBroker() === 'broker'){
      window.open(getCarrierCreateUrl()+'&ContinueBrokerOrgType=true', '_blank');
    }else {
      window.open(getCarrierCreateUrl()+'&ContinueCarrierOrgType=true', '_blank');
    }

  }

  function updateCarrierValues(){
    const asn = getAsn();

    if(asn!=null && asn.asn_org_id !==null && asn.asn_org_id !=="" && asn.asn_org_id !== undefined && asn.asn_org_id!==0 ){
      const carrierBrokerTogglerGroup = new QuickBtnGroup(els.carrierBrokerToggler, {distributeWidth: true});
      carrierBrokerTogglerGroup.init();
   //    if(getCarrierBrokerOrgType() ==='Carrier'){
     if(AsnStore.getCarrierBroker() == 'broker' || AsnStore.getCarrierBroker() == 'transportation broker'){
        els.brokerSelect.val(asn.asn_org_id).trigger('change.select2');
        els.carrierBrokerBtnInputVal.val("broker");
        carrierBrokerTogglerGroup.activateBtnViaKey("broker");
        AsnStore.selectCarrierBroker('broker');
     }else if (AsnStore.getCarrierBroker() == 'carrier'){
        els.shippingSelect.val(asn.asn_org_id).trigger('change.select2');
        els.carrierBrokerBtnInputVal.val("carrier");
        carrierBrokerTogglerGroup.activateBtnViaKey("carrier");
        AsnStore.selectCarrierBroker('carrier');
      }
    }else{
      els.shippingSelect.val(asn.inboundCarrier).trigger('change.select2');
    }
    insertValAndManageFocus(els.otherCarrierInput, asn.asn_carrier_name);
    els.phoneCodeSelect.val(asn.asn_carrier_phone_code).trigger('change.select2');
    insertValAndManageFocus(els.carrierContactNameInput, asn.asn_carrier_contact_name);
    insertValAndManageFocus(els.carrierContactPhoneInput, asn.asn_carrier_phone);
    insertValAndManageFocus(els.carrierBolProNumberInput, asn.asn_bol_pro_number);
    insertValAndManageFocus(els.carrierExpectedArrivalDateInput, asn.asn_expected_arrival_date);
    if(!isBlank(getFirstAsnDetail())) {
      insertValAndManageFocus(els.trackingNumberInput, getFirstAsnDetail()[0].asd_tracking_number);
    }
  }

  function onAsnFieldChangeFunc(asnKeyName){
    let val;
    return (e)=>{
      if(asnKeyName=="asn_save_carrier"){
        onAsnFieldChange(asnKeyName, $(e.target).is(":checked"));
      }else{
        val = $(e.target).val();
        onAsnFieldChange(asnKeyName, val);
      } 
    }
  }

 function onFieldCloneToAsnDetailsChangeFunc(key){
    return (e)=>{
       const val = $(e.target).val();
       onFieldCloneToAsnDetailsChange(key, val);
    }
  }

  function onShippingSelectChangeCb(){ 
    els.carrierBrokerOrgType = 'Carrier';
    const val = els.shippingSelect.val();
    populateCarrierValuesFromStore(val);
  }

  function onBrokerSelectChangeCb(){ 
    els.carrierBrokerOrgType = 'Broker';
    const val = els.brokerSelect.val();
    populateBrokerValuesFromStore(val);
  }

  function onCountryPhoneCodeChangeCb(){
    const val = els.phoneCodeSelect.val();
    onCountryPhoneCodeChange(val);
  }

  function isInboundCarrierOther(){
    let inboundCarrierVal = getAsn().inboundCarrier;
    let defaultCarriersJsonArray = getDefaultCarriers();
    if (inboundCarrierVal !== null){
      if (inboundCarrierVal === "Other") {
        return true;
      }
      for (let keyValue in defaultCarriersJsonArray) {
        if (inboundCarrierVal === defaultCarriersJsonArray[keyValue].cdmValue) {
          return false;
        }
      }
      return true;
    }    
  }

  function validateCarrierName(name){
    if(name == "Other"){
      return true;
    } else if (getDefaultShippingMethod(name)){
      return false;
    }
    return true;
  }

  function populateBrokerValuesFromStore(newBroker){
    const asn = {
      //inboundCarrier: newCarrier
      inboundBroker:newBroker
    };

    let brokerMethodObject = getBrokerMethod(newBroker);
    if(brokerMethodObject){
      asn.asn_org_id = brokerMethodObject.orgId;
      asn.asn_carrier_name = brokerMethodObject.orgName;
      asn.asn_carrier_contact_name = brokerMethodObject.carContactName;
      asn.asn_carrier_phone_code = brokerMethodObject.carPhoneCountryCode;
      asn.asn_carrier_phone = brokerMethodObject.carContactPhone;
    }
    AsnStore.updateObjectAndEmit(getAsn().id, asn);
  }

  function populateCarrierValuesFromStore(newCarrier){
    const asn = {
      inboundCarrier: newCarrier
    };

    let shippingMethodObject = getShippingMethod(newCarrier);
    if(shippingMethodObject){
      asn.asn_org_id = shippingMethodObject.orgId;
      if(asn.asn_org_id===null){
        asn.asn_carrier_name = shippingMethodObject.carName;
      }else{
        asn.asn_carrier_name = shippingMethodObject.orgName;
      }
      asn.asn_carrier_contact_name = shippingMethodObject.carContactName;
      asn.asn_carrier_phone_code = shippingMethodObject.carPhoneCountryCode;
      asn.asn_carrier_phone = shippingMethodObject.carContactPhone;
    }else{
      shippingMethodObject = getDefaultShippingMethod(newCarrier);
      if(shippingMethodObject && shippingMethodObject.cdmValue != 'Other'){
        asn.asn_carrier_name = shippingMethodObject.cdmValue;
        asn.asn_carrier_contact_name = "";
        asn.asn_carrier_phone_code = "";
        asn.asn_carrier_phone = "";
      }else{
        asn.asn_carrier_name = "";
        asn.asn_carrier_contact_name = "";
        asn.asn_carrier_phone_code = "";
        asn.asn_carrier_phone = "";
      }
    }

    AsnStore.updateObjectAndEmit(getAsn().id, asn);
  }



  function getDefaultShippingMethod(search){
    let defaultCarriersJsonArray = getDefaultCarriers();
    return _(defaultCarriersJsonArray).findWhere({ cdmValue: search });
  }

  function getShippingMethod (name) {
    return ShippingMethodStore.getShippingMethod(name);
  }

  function getShippingMethods(){
    return ShippingMethodStore.getShippingMethods();
  }
  function getBrokerMethod (name) {
    return BrokerStore.getBroker(name);
  }

  function getBrokers(){
    return BrokerStore.getBrokers();
  }

  function getFirstAsnDetail(){
    return getAsnDetailGroups()[0];
  }

  function buildModalHtml(){
     carrierBrokerModal = $(render(
       modalHtml,
       {
        title: 'Create Organization',
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-500",
        body: createCarrierOrBrokerModalBodyHtml,
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn continue-btn">Continue</a>
          `
       }
     ));
    carrierBrokerModal.modal(modalOpts);

    $('body').append(carrierBrokerModal);
  }

  function showCarrierOrgModal(e){
    e.preventDefault();
    carrierBrokerModal.modal('show');

  }
  

}



// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/InboundCarrierView.js